import { Component, HostBinding } from '@angular/core';
import { JWTUser } from "@models/jwt-data.model";
import { Log } from "ng2-logger";
import { ResolutionService } from "@services/resolution.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { AuthenticationService } from '@app/authentication/services/authentication.service';

@UntilDestroy()
@Component({
    selector: 'app-authentication',
    templateUrl: './authentication.component.html',
    styleUrls: ['./authentication.component.scss']
})
export class AuthenticationComponent {
    _logger = Log.create(AuthenticationComponent.name);

    focused = true;
    forgotPassword = false;
    user: JWTUser;
    login: boolean;

    @HostBinding('class.mobile') isMobile = false;


    constructor(
        private resolutionService: ResolutionService,
        private authService: AuthenticationService
    ) {
        this.resolutionService.screenSize$.pipe(untilDestroyed(this)).subscribe(screen => {
            this.isMobile = screen.mobile;
        })
    }

    isLegacyAuthRequired(): boolean {
        return this.authService.isLegacyAuth();
    }
}
